import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { applyMiddleware, createStore, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
import reducers from './reducers';
import logger from './utility/common/Logger'
import monitorReducerEnhancer from './utility/common/MonitorReducer'
import { Provider } from 'react-redux';

import { Router } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import history from './utility/common/History.js';

import { StyledEngineProvider } from '@mui/material/styles';
import ObiThemeProvider from './components/common/ObiThemeProvider';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

const { REACT_APP_TYPE, REACT_APP_VERSION } = process.env;

const persistConfig = {
  key: 'root',
  storage,
  //whitelist: ['user']
}

const getMiddleWares = () => {
  let middlewares = [thunk];

  if (REACT_APP_TYPE !== 'production'){
    middlewares.push(logger);
  }

  return applyMiddleware(...middlewares);
}

const middlewareEnhancer = getMiddleWares();
const composedEnhancers = compose(middlewareEnhancer, monitorReducerEnhancer)

const persistedReducer = persistReducer(persistConfig, reducers)

const store = createStore(persistedReducer, undefined, composedEnhancers)

const persistor = persistStore(store)

/*
const APP_VERSION = process.env.REACT_APP_VERSION;

if (typeof localStorage.APP_VERSION === 'undefined' || localStorage.APP_VERSION === null) {
  localStorage.setItem('APP_VERSION', APP_VERSION);
}
else if (localStorage.APP_VERSION != APP_VERSION) {
  localStorage.clear();
}*/



//const store = createStore(reducers, {}, applyMiddleware(thunk));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router history={history}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <StyledEngineProvider injectFirst>
              <ObiThemeProvider>
                <App />
              </ObiThemeProvider>
            </StyledEngineProvider>
          </LocalizationProvider>
        </Router>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
